exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-524c71b6] {\n  border: 2px solid #90CC1B !important;\n  border-radius: 5px;\n  color: #90CC1B;\n  margin-right: 10px;\n  background-color: transparent;\n}\n.button .text[data-v-524c71b6] {\n  font-size: 12px;\n  font-weight: 450;\n}\n.button .icon[data-v-524c71b6] {\n  margin-right: 7px !important;\n}\n.button svg > g > path[data-v-524c71b6] {\n  fill: #000 !important;\n}", ""]);

// exports
